import React from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import {Col, Container, Row} from "react-bootstrap";
import "./two_columns_text.scss";
import {columnLayout} from "../../utils/device";
import {insertHtml} from "../../utils/dom";

interface TwoColumnsTextData {
    title?: string;
    left_title?: string;
    right_title?: string;
    left_text: string;
    right_text: string;

}

class TwoColumnsText extends TemplateComponent<TwoColumnsTextData, TemplateComponentProps<TwoColumnsTextData>> {

    componentRender(data: TwoColumnsTextData): React.ReactElement<any> {

        return (
            <Container className="c6-two-columns-text auto-margins">
                {data.title &&
                    <h3 className="component-title">{data.title}</h3>
                }
                <Row>
                    <Col {...columnLayout(6)}>
                        <div className="text-column">
                            {
                                data.left_title &&
                                    <h5 className="title">{data.left_title}</h5>
                            }
                            <p className="text editor-html editor-html-right-col" {...insertHtml(data.left_text)} />
                        </div>
                    </Col>
                    <Col {...columnLayout(6)}>
                        <div className="text-column">
                            {
                                (data.left_title || data.right_title) &&
                                    <h5 className="title">{data.right_title ? data.right_title : ""}</h5>
                            }
                            <p className="text editor-html editor-html-right-col" {...insertHtml(data.right_text)} />
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default TwoColumnsText;